package one.healthium.ui.compose.components.banner

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.saveable.Saver
import androidx.compose.runtime.saveable.rememberSaveable
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

@Stable
class BannerHostState<T : BannerData>(
    initialBanners: List<T> = emptyList()
) {
    private val _banners = MutableStateFlow(initialBanners)
    val banners: StateFlow<List<T>> = _banners.asStateFlow()

    fun showBanner(data: T) {
        _banners.update { currentBanners ->
            val topBanner = currentBanners.firstOrNull()
            if (topBanner != null && topBanner == data) {
                currentBanners
            } else {
                currentBanners + data
            }
        }
    }

    fun dismissBanner(id: String) {
        _banners.update { list -> list.filter { it.id != id } }
    }

    fun dismissAll() {
        _banners.value = emptyList()
    }

    companion object {
        fun <T : BannerData> Saver(): Saver<BannerHostState<T>, List<T>> = Saver(
            save = { it.banners.value },
            restore = { BannerHostState(it) }
        )
    }
}

@Composable
fun <T : BannerData> rememberBannerHostState(
    vararg inputs: Any?,
    saver: Saver<BannerHostState<T>, *> = BannerHostState.Saver(),
    init: () -> BannerHostState<T> = { BannerHostState() }
): BannerHostState<T> {
    return rememberSaveable(inputs = inputs, saver = saver, init = init)
}

val LocalBannerHostState = compositionLocalOf<BannerHostState<*>?> { null }
